import { Routes } from '@angular/router';

import { AuthGuard } from './utils/auth.guard';
import { AdminGuard } from './utils/admin.guard';
import { LogTimeGuard } from './utils/log-time.guard';
import { AnalyticsGuard } from './utils/analytics.guard';
import { projectPageCanDeactivate } from './utils/project-page.guard';

import { PageLayoutComponent } from '@components';

import {
  LoginPage,
  ForgotPasswordPage,
  ProjectPage,
  ProjectsPage,
  TimeSheetPage,
  HomePage,
  SettingsPage,
  AgentTokensPage,
  ProfilePage,
  AnalyticsPage,
  ProjectAnalyticsPage,
  LandingPage,
} from '@pages';

export const routes: Routes = [
  // PUBLIC LANDING
  { path: '', component: LandingPage, pathMatch: 'full' },

  // AUTH
  { path: 'login', component: LoginPage },
  { path: 'forgot-password', component: ForgotPasswordPage },

  {
    path: '',
    component: PageLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        canActivate: [LogTimeGuard],
        component: HomePage,
      },
      {
        path: 'profile',
        component: ProfilePage,
      },
      {
        path: 'projects',
        canActivate: [AdminGuard],
        component: ProjectsPage,
      },
      {
        path: 'projects/project',
        canActivate: [AdminGuard],
        canDeactivate: [projectPageCanDeactivate],
        component: ProjectPage,
      },
      {
        path: 'settings',
        component: SettingsPage,
      },
      {
        path: 'settings/agent-tokens',
        component: AgentTokensPage,
      },
      {
        path: 'time-sheet',
        canActivate: [LogTimeGuard],
        component: TimeSheetPage,
      },
      {
        path: 'analytics',
        canActivate: [AnalyticsGuard],
        component: AnalyticsPage,
      },
      {
        path: 'analytics/:projectId',
        canActivate: [AnalyticsGuard],
        component: ProjectAnalyticsPage,
      },
    ],
  },
  { path: '**', redirectTo: '/home' },
];
